(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const theme = (window.theme = window.theme || {});
    const SECTION = 'cart-drawer';

    const root = () => document.querySelector('[data-cart-drawer]');

    const render = (sections) => {
      const html = sections?.[SECTION];
      const current = root();
      if (!html || !current) return;

      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
      if (!fresh) return;
      current.replaceWith(fresh);

      const count = fresh.dataset.cartCount;
      document.querySelectorAll('[data-cart-count-bubble]').forEach((bubble) => {
        bubble.textContent = count;
        bubble.classList.remove('is-bumped');
        void bubble.offsetWidth;
        bubble.classList.add('is-bumped');
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: Number(count) } }));
    };

    const request = async (url, body) => {
      const response = await fetch(url, {
        method: 'POST',
        headers: body instanceof FormData ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body instanceof FormData ? body : JSON.stringify(body),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || response.statusText);
      return data;
    };

    theme.cart = {
      get enabled() {
        return Boolean(document.getElementById('CartDrawer'));
      },

      async add(formData) {
        formData.append('sections', SECTION);
        formData.append('sections_url', window.location.pathname);
        const data = await request(`${window.Shopify?.routes?.root || '/'}cart/add.js`, formData);
        render(data.sections);
        theme.openDialog('CartDrawer');
        return data;
      },

      async change(line, quantity) {
        const drawer = root();
        drawer?.classList.add('is-updating');
        try {
          const data = await request(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
            line,
            quantity,
            sections: SECTION,
            sections_url: window.location.pathname,
          });
          render(data.sections);
        } catch (error) {
          drawer?.classList.remove('is-updating');
          const message = root()?.querySelector('[data-cart-error]');
          if (message) {
            message.textContent = error.message;
            message.hidden = false;
          }
        }
      },
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cart-line]');
      if (!button || !button.closest('[data-cart-drawer]')) return;
      theme.cart.change(Number(button.dataset.cartLine), Number(button.dataset.cartQuantity));
    });

    // Product forms and quick-add buttons: add without leaving the page when the drawer exists.
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-product-form]');
      if (!form || !theme.cart.enabled) return;
      event.preventDefault();

      const button = form.querySelector('[type="submit"]');
      const error = form.querySelector('[data-form-error]');
      button?.setAttribute('aria-busy', 'true');
      if (error) error.hidden = true;

      try {
        await theme.cart.add(new FormData(form));
      } catch (exception) {
        if (error) {
          error.textContent = exception.message;
          error.hidden = false;
        }
      } finally {
        button?.removeAttribute('aria-busy');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Quantity changes post the cart form, which updates the cart and reloads the page.
  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-cart-form]');
    if (form && event.target.name === 'updates[]') form.requestSubmit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    /* Sticky header: shadow once scrolled, nav row folds away while scrolling down */
    let lastY = window.scrollY;
    let ticking = false;

    const update = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 4);
      if (y > 160 && y > lastY + 4) header.classList.add('is-condensed');
      else if (y < lastY - 4 || y <= 160) header.classList.remove('is-condensed');
      lastY = y;
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    requestAnimationFrame(update);

    /* Desktop dropdowns open on hover (and still toggle on click/keyboard) */
    const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
    header.querySelectorAll('[data-hover-dropdown]').forEach((dropdown) => {
      let timer;
      dropdown.addEventListener('mouseenter', () => {
        if (!hoverCapable.matches) return;
        clearTimeout(timer);
        dropdown.open = true;
      });
      dropdown.addEventListener('mouseleave', () => {
        if (!hoverCapable.matches) return;
        timer = setTimeout(() => (dropdown.open = false), 150);
      });
    });

    document.addEventListener('click', (event) => {
      header.querySelectorAll('.main-nav__dropdown[open]').forEach((dropdown) => {
        if (!dropdown.contains(event.target)) dropdown.open = false;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      header.querySelectorAll('.main-nav__dropdown[open]').forEach((dropdown) => {
        dropdown.open = false;
        dropdown.querySelector('summary').focus();
      });
    });

    /* Predictive search: rendered by the `predictive-search` section */
    const form = header.querySelector('[data-predictive-search]');
    const input = form?.querySelector('input[name="q"]');
    const results = form?.querySelector('[data-predictive-results]');
    if (!form || !input || !results) return;

    let controller;
    let debounce;

    const close = () => {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };

    const open = () => {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const skeleton = `<div class="predictive-search__loading" aria-hidden="true">${'<div class="predictive-search__skeleton"><span class="skeleton"></span><span><span class="skeleton"></span><span class="skeleton"></span></span></div>'.repeat(3)}</div>`;

    const search = async (terms) => {
      controller?.abort();
      controller = new AbortController();
      results.innerHTML = skeleton;
      open();

      const params = new URLSearchParams({
        q: terms,
        'resources[type]': 'product,collection,query',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
        section_id: 'predictive-search',
      });

      try {
        const response = await fetch(`${form.dataset.predictiveUrl}?${params}`, { signal: controller.signal });
        if (!response.ok) throw new Error(response.statusText);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('[data-predictive-content]');
        results.innerHTML = content ? content.outerHTML : '';
        if (!content) close();
      } catch (error) {
        if (error.name !== 'AbortError') close();
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(debounce);
      const terms = input.value.trim();
      if (terms.length < 2) {
        controller?.abort();
        close();
        return;
      }
      debounce = setTimeout(() => search(terms), 220);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2 && results.innerHTML) open();
    });

    form.addEventListener('keydown', (event) => {
      if (results.hidden) return;
      const items = [...results.querySelectorAll('a')];
      const index = items.indexOf(document.activeElement);

      if (event.key === 'Escape') {
        close();
        input.focus();
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        items[Math.min(index + 1, items.length - 1)]?.focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (index <= 0) input.focus();
        else items[index - 1].focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const layer = document.querySelector('[data-hero-parallax]');
    const desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    if (!layer || window.theme?.reducedMotion?.matches) return;

    // Subtle depth: the photo drifts at ~12% of the scroll speed while the hero is on screen.
    let ticking = false;
    const update = () => {
      ticking = false;
      if (!desktop.matches) {
        layer.style.transform = '';
        return;
      }
      const y = Math.min(window.scrollY, 500);
      layer.style.transform = `translate3d(0, ${(y * 0.12).toFixed(1)}px, 0)`;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    desktop.addEventListener('change', update);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-recommendations-url]').forEach(async (container) => {
    try {
      const response = await fetch(container.dataset.recommendationsUrl);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = html.querySelector('[data-recommendations-url] .product-grid');
      const grid = container.querySelector('.product-grid');
      if (!fresh || !fresh.children.length) return container.remove();
      grid.innerHTML = fresh.innerHTML;
      window.theme?.reveal?.(container);
      document.dispatchEvent(new Event('wishlist:sync'));
    } catch {
      // Recommendations are optional; remove the placeholders on failure.
      container.remove();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const gallery = document.querySelector('[data-gallery]');
    if (gallery) {
      const track = gallery.querySelector('[data-gallery-track]');
      const slides = () => [...track.children].sort((a, b) => a.offsetLeft - b.offsetLeft);

      const setActive = (index) => {
        const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')].sort(
          (a, b) => a.offsetLeft - b.offsetLeft
        );
        const dots = [...gallery.querySelectorAll('.product__dot')].sort((a, b) => a.offsetLeft - b.offsetLeft);
        [thumbs, dots].forEach((list) =>
          list.forEach((item, i) => {
            item.classList.toggle('is-active', i === index);
            if (item.matches('[data-gallery-thumb]')) item.toggleAttribute('aria-current', i === index);
          })
        );
      };

      const goTo = (slide) => track.scrollTo({ left: slide.offsetLeft - track.offsetLeft });

      track.addEventListener(
        'scroll',
        () => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          setActive(index);
        },
        { passive: true }
      );

      gallery.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (thumb) goTo(document.getElementById(thumb.dataset.galleryThumb));

        const step = event.target.closest('[data-gallery-step]');
        if (step) {
          const list = slides();
          const index = Math.round(track.scrollLeft / track.clientWidth);
          const next = (index + Number(step.dataset.galleryStep) + list.length) % list.length;
          goTo(list[next]);
        }
      });

      // Hover zoom follows the cursor (desktop only)
      const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      track.addEventListener('mousemove', (event) => {
        const slide = event.target.closest('[data-zoom]');
        if (!slide || !fine.matches || window.theme?.reducedMotion?.matches) return;
        const rect = slide.getBoundingClientRect();
        slide.style.setProperty('--zoom-x', `${((event.clientX - rect.left) / rect.width) * 100}%`);
        slide.style.setProperty('--zoom-y', `${((event.clientY - rect.top) / rect.height) * 100}%`);
        slide.classList.add('is-zooming');
      });
      track.addEventListener('mouseleave', () =>
        track.querySelectorAll('.is-zooming').forEach((slide) => slide.classList.remove('is-zooming'))
      );
    }

    // Sticky buy bar appears once the main buy box has scrolled out of view
    const buy = document.querySelector('[data-product-buy]');
    const sticky = document.querySelector('[data-product-sticky]');
    if (buy && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.toggleAttribute('inert', !show);
        sticky.setAttribute('aria-hidden', String(!show));
      }).observe(buy);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  (() => {
    const grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    const render = async () => {
      let handles = [];
      try {
        handles = JSON.parse(localStorage.getItem('oferti:wishlist')) || [];
      } catch {}

      const root = window.Shopify?.routes?.root || '/';
      const empty = document.querySelector('[data-wishlist-empty]');
      if (handles.length && !grid.children.length) {
        empty.hidden = true;
        grid.innerHTML = '<div class="product-card product-card--skeleton" aria-hidden="true"><div class="product-card__link"><span class="product-card__media skeleton"></span><span class="skeleton" style="height:.8rem;width:75%"></span><span class="skeleton" style="height:1.2rem;width:35%;margin-top:.6rem"></span></div></div>'.repeat(Math.min(handles.length, 5));
      }
      const cards = await Promise.all(
        handles.map((handle) =>
          fetch(`${root}products/${encodeURIComponent(handle)}?view=card`)
            .then((response) => (response.ok ? response.text() : ''))
            .catch(() => '')
        )
      );

      grid.innerHTML = cards.join('');
      empty.hidden = grid.children.length > 0;
      window.theme?.reveal?.(grid);
      document.dispatchEvent(new Event('wishlist:sync'));
    };

    // Removing a heart on this page removes the card too.
    document.addEventListener('wishlist:change', render);
    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
